import api from './api'; // axios instance

const invoiceService = {
  // Get next invoice number
  getNextInvoiceNumber: async () => {
    const token = localStorage.getItem("auth_token");
    const response = await api.get("/api/check-invoice", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },
};

export default invoiceService;